import React from 'react';

import { useEditableWidget } from '@lumapps/designer-legacy-widget-settings/hooks/useEditableWidget';
import type { EditableWidgetProps } from '@lumapps/designer-legacy-widget-settings/types';
import { BackendRecomputedWidget } from '@lumapps/widget-base/components/BackendRecomputedWidget';

import type { LegacyWidgetTitleProps } from '../../type';
import { EditableWidgetTitle, EditableWidgetTitleProps } from './EditableWidgetTitle';

export interface LegacyWidgetTitleWrapperProps extends EditableWidgetProps<LegacyWidgetTitleProps> {}

export interface EditableWidgetTitleProperties {
    content?: string;
}

export const LegacyWidgetTitleWrapper: React.FC<LegacyWidgetTitleWrapperProps> = ({
    legacyWidget: initLegacyWidget,
    switchToReadMode,
    saveTextInWidgetProperties,
    isEditingContent,
    isWidgetEmpty,
    contentTitle,
    ...props
}) => {
    const getTranslateObject = React.useCallback((properties?: LegacyWidgetTitleProps) => properties?.content, []);

    const { legacyWidget, content, editableWidgetProps } = useEditableWidget<LegacyWidgetTitleProps>(
        { ...initLegacyWidget, properties: { ...initLegacyWidget?.properties, content: contentTitle } },
        switchToReadMode,
        saveTextInWidgetProperties,
        getTranslateObject,
        true,
    );

    return (
        <BackendRecomputedWidget<LegacyWidgetTitleProps, EditableWidgetTitleProperties, EditableWidgetTitleProps>
            legacyWidget={legacyWidget}
            editableWidgetRenderer={EditableWidgetTitle}
            editableWidgetProps={editableWidgetProps}
            isWidgetEmpty={isWidgetEmpty}
            blockProperties={{ content }}
            editingContent={isEditingContent}
            canUseLangFallback={false}
            {...props}
        />
    );
};
